/* eslint-disable no-undef */
// import { openCompanyServices } from '@/redux/actions/redirectActions';
import { SkeletonLoader } from '@/shared/components/Skeleton/BasicSkeletonShapes';
import Tooltip from '@/shared/components/Tooltip';
import {
	ElectronFrameworkIcon,
	ShieldCrownIcon,
	ShieldCrownOutlineIcon,
} from '@/shared/dynamicImports';
import insertBrAfterThirdSpace from '@/utils/breakstring';
import { left } from '@/utils/directions';
import useUrlQueryParams from '@/utils/hooks/useUrlQueryParams';
import {
	colorAccent,
	colorBackground,
	colorBorder,
	colorHover,
	colorText,
	sidebarColor,
} from '@/utils/palette';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import SidebarCategory from './SidebarCategory';
import SidebarExternalLink from './SidebarExternalLink';
import SidebarLink, { SidebarLinkTitle, SidebarNavLink } from './SidebarLink';
const SidebarContent = ({
	onClick,
	changeToLight,
	changeToDark,
	collapse = false,
}) => {
	// const dispatch = useDispatch();
	const customerID = useSelector(
		state => state?.customer?.currentCustomer?.customerID,
	);
	const monitoringUrl = useSelector(
		state => state?.customer?.currentCustomer?.monitoringUrl,
	);
	const { encryptQueryParams } = useUrlQueryParams();
	const encryptedComapanyParams = encryptQueryParams({ customerID });
	// const { allowedModulePermissions, scopePermissions } = useSelector((state) => state?.permissionsStorage);
	const allowedModulePermissions = useSelector(
		state => state?.permissionsStorage?.allowedModulePermissions,
	);

	const scopePermissions = useSelector(
		state => state?.permissionsStorage?.scopePermissions,
	);
	const currentSite = useSelector(state => state?.site?.currentSite);
	const customerOnboarded = useSelector(
		state => state?.auth?.currentUser?.customerOnboarded,
	);

	const releaseVersion = __RELEASE_VERSION__.split('-')[0];
	const currentCustomerName = useSelector(
		state => state?.customer?.currentCustomer?.customerName,
	);
	const customerName = useSelector(state => state?.customer?.customerName);
	const selectedCustomer = useSelector(
		state => state?.customer?.currentCustomer?.customerName,
	);
	console.log(selectedCustomer);
	console.log(customerName);

	// useEffect(() => {
	//   dispatch(openCompanyServices());
	// }, []);

	return (
		<SkeletonLoader
			isLoading={!allowedModulePermissions}
			numLines={15}
			width="100%"
			height="20px"
		>
			<SidebarContentWrap collapse={collapse && customerOnboarded === true}>
				<SidebarBlock collapse={collapse && customerOnboarded === true}>
					<SidebarCategory
						title="Theme"
						icon="pointer-right"
						collapse={collapse}
					>
						<SidebarNavLink as="button" type="button" onClick={changeToLight}>
							<SidebarLinkTitle>
								<span
									className="lnr lnr-sun"
									style={{
										width: '10px',
										height: '10px',
										marginRight: '10px',
										marginBottom: '5px',
									}}
								>
									{' '}
								</span>
								&nbsp;Light Theme
							</SidebarLinkTitle>
						</SidebarNavLink>
						<SidebarNavLink as="button" type="button" onClick={changeToDark}>
							<SidebarLinkTitle>
								<span
									className="lnr lnr-moon"
									style={{
										width: '10px',
										height: '10px',
										marginRight: '10px',
										marginBottom: '5px',
									}}
								>
									{' '}
								</span>
								&nbsp;Dark Theme
							</SidebarLinkTitle>
						</SidebarNavLink>
					</SidebarCategory>
				</SidebarBlock>
				<SidebarBlock collapse={collapse}>
					{collapse ? (
						<SidebarNavLink as="div">
							{scopePermissions?.isStnUser && (
								<SidebarLinkTitle
									collapse={collapse}
									style={{
										color: colorText,
										textDecoration: 'underline',
										fontSize: '10px',
										textTransform: 'uppercase',
										alignItems: 'center',
									}}
								>
									<Tooltip
										dir="right"
										text={
											<>
												{insertBrAfterThirdSpace(
													currentCustomerName || customerName,
												)}
												{' > '}
												{currentSite?.label}
											</>
										}
										variant="primary"
									>
										<span>
											<ElectronFrameworkIcon
												style={{
													color: colorText,
													width: '16px',
													height: '16px',
												}}
											/>
										</span>
									</Tooltip>
								</SidebarLinkTitle>
							)}
						</SidebarNavLink>
					) : (
						<SidebarNavLink as="div">
							{scopePermissions?.isStnUser && (
								<SidebarLinkTitle
									collapse={collapse}
									style={{
										color: colorText,
										textDecoration: 'underline',
										fontSize: '10px',
										textTransform: 'uppercase',
									}}
								>
									{insertBrAfterThirdSpace(currentCustomerName || customerName)}{' '}
									{' > '} {currentSite?.label}
								</SidebarLinkTitle>
							)}
						</SidebarNavLink>
					)}
					{allowedModulePermissions?.some(item =>
						item.path.includes('documents'),
					) && (
						<SidebarCategory
							title="Documents"
							icon="file-empty"
							collapse={collapse}
						>
							{allowedModulePermissions?.some(item =>
								item.path.includes('documents'),
							) && (
								<SidebarLink
									title="Diagrams"
									route="/documents/diagrams/"
									icon="picture"
									onClick={onClick}
								/>
							)}
							{allowedModulePermissions?.some(item =>
								item.path.includes('documents'),
							) && (
								<SidebarLink
									title="Files"
									route="/documents/files/"
									icon="layers"
									onClick={onClick}
								/>
							)}
						</SidebarCategory>
					)}
					{/* {allowedModulePermissions?.some((item) => item.path === '/onboarding_system/') && (
            <SidebarLink
              title='Onboarding System'
              route='/onboarding_system/'
              icon='rocket'
            />
          )} */}
					{allowedModulePermissions?.some(
						item => item.path === '/projects/',
					) && (
						<SidebarLink title="Projects" route="/projects/" icon="rocket" />
					)}
					{allowedModulePermissions?.some(
						item => item.path === '/tickets/',
					) && <SidebarLink title="Tickets" route="/tickets/" icon="tag" />}
					{allowedModulePermissions?.some(
						item => item.path === '/reports/',
					) && (
						<SidebarLink
							title="Reports"
							route="/reports/"
							icon="book"
							onClick={onClick}
						/>
					)}
					{allowedModulePermissions?.some(
						item =>
							item.path === '/vulnerability_scans_dashboard/' ||
							item.path === '/vulnerability_scans/' ||
							item.path === '/assessments/',
					) && (
						<SidebarCategory
							title="Assessments and Security"
							icon="lock"
							collapse={collapse}
						>
							{allowedModulePermissions?.some(
								item => item.path === '/vulnerability_scans_dashboard/',
							) && (
								<SidebarLink
									title="Dashboard"
									route="/vulnerability_scans_dashboard/"
									onClick={onClick}
								/>
							)}
							{allowedModulePermissions?.some(
								item => item.path === '/vulnerability_scans/',
							) && (
								<SidebarLink
									title="Vulnerability Scans"
									route="/vulnerability_scans/"
									onClick={onClick}
								/>
							)}
							{allowedModulePermissions?.some(
								item => item.path === '/assessments/',
							) && (
								<SidebarLink
									title="Assessments"
									route="/assessments/"
									onClick={onClick}
								/>
							)}
						</SidebarCategory>
					)}
					<>
						{allowedModulePermissions?.some(
							item =>
								item.path === '/virtual_machines_dashboard/' ||
								item.path === '/private_networks/' ||
								item.path === '/virtual_machines/' ||
								item.path === '/gpu/',
						) ? (
							<SidebarCategory
								title="Infastructure Services"
								icon="screen"
								collapse={collapse}
							>
								{allowedModulePermissions?.some(
									item => item.path === '/virtual_machines_dashboard/',
								) && (
									<SidebarLink
										title="Dashboard"
										route="/virtual_machines_dashboard/"
										onClick={onClick}
									/>
								)}
								{allowedModulePermissions?.some(
									item => item.path === '/private_networks/',
								) && (
									<SidebarLink
										title="Private Network"
										route="/private_networks/"
										onClick={onClick}
									/>
								)}
								{allowedModulePermissions?.some(
									item => item.path === '/virtual_machines/',
								) ? (
									<SidebarLink
										title="Virtual Machines"
										route="/virtual_machines/"
										onClick={onClick}
									/>
								) : null}
								{allowedModulePermissions?.some(
									item => item.path === '/virtual_gateway/',
								) ? (
									<SidebarLink
										title="Virtual Gateway"
										route="/virtual_gateway/"
										onClick={onClick}
									/>
								) : null}
								{allowedModulePermissions?.some(
									item => item.path === '/kubernetes/',
								) ? (
									<SidebarLink
										title="Kubernetes"
										route="/kubernetes/"
										onClick={onClick}
									/>
								) : null}
								{allowedModulePermissions?.some(
									item => item.path === '/gpu/',
								) ? (
									<SidebarLink
										title="GPU One"
										route="/gpu/"
										onClick={onClick}
									/>
								) : null}
								{monitoringUrl && (
									<SidebarExternalLink
										title="Monitoring"
										url={monitoringUrl}
										onClick={onClick}
									/>
								)}
							</SidebarCategory>
						) : null}
					</>
					{allowedModulePermissions?.some(
						item =>
							(item.path === '/inventory_dashboard/' ||
								item.path === '/inventory_management/') &&
							scopePermissions?.isStnUser,
					) && (
						<SidebarCategory
							title="Inventory"
							icon="lnr lnr-construction"
							collapse={collapse}
						>
							{allowedModulePermissions?.some(
								item => item.path === '/inventory_dashboard/',
							) && (
								<SidebarLink
									title="Dashboard"
									icon="earth"
									route="/inventory_dashboard/"
									onClick={onClick}
								/>
							)}
							{allowedModulePermissions?.some(
								item => item.path === '/inventory_management/',
							) && (
								<SidebarLink
									title="Inventory Management"
									icon="lnr lnr-construction"
									route="/inventory_management/"
									onClick={onClick}
								/>
							)}
						</SidebarCategory>
					)}
				</SidebarBlock>

				{allowedModulePermissions?.some(
					item =>
						item.path.includes('permissions') ||
						item.path.includes('alerts_services') ||
						item.path === '/users/' ||
						item.path === '/audit_logs/' ||
						item.path === '/alert_contacts/' ||
						item.path === '/company/',
				) ? (
					<SidebarBlock collapse={collapse}>
						<>
							{collapse ? (
								<SidebarNavLink as="div">
									<SidebarLinkTitle
										collapse={collapse}
										style={{
											color: colorText,
											textDecoration: 'underline',
											fontSize: '10px',
											textTransform: 'uppercase',
											alignItems: 'center',
										}}
									>
										<Tooltip dir="right" text="Admin" variant="primary">
											<span>
												<ShieldCrownOutlineIcon
													style={{
														color: colorText,
														width: '16px',
														height: '16px',
													}}
												/>
											</span>
										</Tooltip>
									</SidebarLinkTitle>
								</SidebarNavLink>
							) : (
								<SidebarNavLink as="div">
									<SidebarLinkTitle
										collapse={collapse}
										style={{
											color: colorText,
											textDecoration: 'underline',
											fontSize: '10px',
											textTransform: 'uppercase',
										}}
									>
										Admin
									</SidebarLinkTitle>
								</SidebarNavLink>
							)}
							{allowedModulePermissions?.some(
								item =>
									item.path === '/permissions_roles/' ||
									item.path.includes('permissions'),
							) && customerName == 'Stn inc' ? (
								<SidebarCategory
									title="Permissions"
									icon="select"
									collapse={collapse}
								>
									<SidebarLink
										title="Roles"
										icon="graduation-hat"
										route="/permissions_roles/"
									/>
									<SidebarLink
										title="Teams"
										icon="users"
										route="/permissions_teams/"
									/>
								</SidebarCategory>
							) : null}

							{allowedModulePermissions?.some(
								item => item.path === '/users/',
							) && (
								<SidebarLink
									title="Manage Users"
									icon="user"
									route="/users/"
									onClick={onClick}
								/>
							)}
							{allowedModulePermissions?.some(
								item => item.path === '/audit_logs/',
							) && (
								<SidebarLink
									title="Audit Logs"
									icon="pencil"
									route="/audit_logs/"
									onClick={onClick}
								/>
							)}
						</>

						{allowedModulePermissions?.some(
							item => item.path === '/alert_contacts/',
						) &&
							scopePermissions?.isStnUser && (
								<SidebarLink
									title="Alert Contacts"
									icon="phone"
									route="/alert_contacts/"
									onClick={onClick}
								/>
							)}
						{allowedModulePermissions?.some(
							item => item.path === '/company/',
						) &&
							scopePermissions?.isStnUser && (
								<SidebarLink
									title="Company Settings"
									icon="apartment"
									route={`/company/${customerName}?${encryptedComapanyParams}`}
									onClick={onClick}
								/>
							)}
						{allowedModulePermissions?.some(item =>
							item.path.includes('alerts_services'),
						) &&
							scopePermissions?.isStnUser && (
								<SidebarCategory
									title="Alerts Services"
									icon="lnr lnr-license"
									collapse={collapse}
								>
									<SidebarLink
										title="Enable Alert Services"
										icon="laptop"
										route="/alerts_services/enablealerts/"
										onClick={onClick}
									/>
									<SidebarLink
										title="Tools Mapping"
										icon="indent-increase"
										route="/alerts_services/tools_mapping/"
										onClick={onClick}
									/>
									<SidebarLink
										title="Project Mapping"
										icon="map"
										route="/alerts_services/tools_projects/"
										onClick={onClick}
									/>
								</SidebarCategory>
							)}
					</SidebarBlock>
				) : null}
				{allowedModulePermissions?.some(
					item =>
						item.path === '/alltickets/' ||
						item.path === '/alerts_services/tools_mapping/' ||
						item.path === '/alerts_services/tools_projects/' ||
						item.path === '/dev_permission_resource/' ||
						item.path === '/alerts_policy/' ||
						item.path === '/allprojects/' ||
						item.path === '/all_projects_tickets/' ||
						item.path === '/companymanagement/' ||
						item.path === '/all_users/' ||
						item.path === '/services/' ||
						item.path === '/time_reporting/' ||
						item.path === '/regions/' ||
						item.path === '/all_virtual_machines/' ||
						item.path === '/all_private_networks/' ||
						item.path === '/one_servers/' ||
						item.path === '/vm_templates/' ||
						item.path === '/manage_notifications/' ||
						item.path === '/integrations/' ||
						item.path === '/tickets_dashboard/',
				) ? (
					<>
						{allowedModulePermissions?.some(
							item =>
								item.path === '/alltickets/' ||
								item.path.includes('alerts_services') ||
								item.path === '/allprojects/' ||
								item.path === '/all_projects_tickets/' ||
								item.path === '/companymanagement/' ||
								item.path === '/users/' ||
								item.path === '/services/' ||
								item.path === '/time_reporting/' ||
								item.path === '/control_group_templates/' ||
								item.path === '/regions/' ||
								item.path === '/all_virtual_machines/' ||
								item.path === '/all_private_networks/' ||
								item.path === '/one_servers/' ||
								item.path === '/vm_templates/' ||
								item.path === '/all_kubernetes/' ||
								item.path === '/tickets_dashboard/' ||
								item.path === '/skus/',
						) &&
							scopePermissions?.isStnUser && (
								<SidebarBlock collapse={collapse}>
									{collapse ? (
										<SidebarNavLink as="div">
											<SidebarLinkTitle
												collapse={collapse}
												style={{
													color: colorText,
													textDecoration: 'underline',
													fontSize: '10px',
													textTransform: 'uppercase',
													alignItems: 'center',
												}}
											>
												<Tooltip dir="right" text="STN Admin" variant="primary">
													<span>
														<ShieldCrownIcon
															style={{
																color: colorText,
																width: '16px',
																height: '16px',
															}}
														/>
													</span>
												</Tooltip>
											</SidebarLinkTitle>
										</SidebarNavLink>
									) : (
										<SidebarNavLink as="div">
											<SidebarLinkTitle
												collapse={collapse}
												style={{
													color: colorText,
													textDecoration: 'underline',
													fontSize: '10px',
													textTransform: 'uppercase',
												}}
											>
												STN Admin
											</SidebarLinkTitle>
										</SidebarNavLink>
									)}
									{allowedModulePermissions?.some(
										item =>
											item.path === '/alltickets/' ||
											item.path === '/allprojects/' ||
											item.path === '/all_projects_tickets/' ||
											item.path === '/tickets_dashboard/',
									) && (
										<SidebarCategory
											title="Tickets and Projects"
											icon="lnr lnr-apartment"
											collapse={collapse}
										>
											{allowedModulePermissions?.some(
												item => item.path === '/tickets_dashboard/',
											) && (
												<SidebarLink
													title="My Dashboard"
													icon="list"
													route="/tickets_dashboard/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/alltickets/',
											) && (
												<SidebarLink
													title="All Support Tickets"
													icon="list"
													route="/alltickets/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/allprojects/',
											) && (
												<SidebarLink
													title="All Projects"
													icon="list"
													route="/allprojects/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/all_projects_tickets/',
											) && (
												<SidebarLink
													title="All Projects Tickets"
													icon="list"
													route="/all_projects_tickets/"
													onClick={onClick}
												/>
											)}
										</SidebarCategory>
									)}
									{allowedModulePermissions?.some(
										item =>
											item.path === '/alerts_policy/' ||
											item.path === '/alerts_tools/' ||
											item.path === '/alerts_company_service_list/',
									) && (
										<SidebarCategory
											title="Alerts Configuration"
											icon="lnr lnr-license"
											collapse={collapse}
										>
											{allowedModulePermissions?.some(
												item => item.path === '/alerts_tools/',
											) && (
												<SidebarLink
													title="Tools"
													icon="laptop"
													route="/alerts_tools/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/alerts_policy/',
											) && (
												<SidebarLink
													title="Alerts Policy"
													icon="earth"
													route="/alerts_policy/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/alerts_company_service_list/',
											) && (
												<SidebarLink
													title="Company Service List"
													icon="earth"
													route="/alerts_company_service_list/"
													onClick={onClick}
												/>
											)}
										</SidebarCategory>
									)}

									{allowedModulePermissions?.some(
										item => item.path === '/companymanagement/',
									) && (
										<SidebarLink
											title="Company Management"
											icon="apartment"
											route="/companymanagement/"
											onClick={onClick}
										/>
									)}
									{scopePermissions?.isStnUser &&
										allowedModulePermissions?.some(
											item => item.path === '/all_users/',
										) && (
											<SidebarLink
												title="User Management"
												icon="users"
												route="/all_users/"
												onClick={onClick}
											/>
										)}
									{allowedModulePermissions?.some(
										item => item.path === '/services/',
									) && (
										<SidebarLink
											title="STN Services"
											icon="diamond"
											route="/services/"
											onClick={onClick}
										/>
									)}
									{allowedModulePermissions?.some(
										item => item.path === '/time_reporting/',
									) &&
										scopePermissions?.isStnUser && (
											<SidebarLink
												title="Time Reporting"
												icon="clock"
												route="/time_reporting/"
												onClick={onClick}
											/>
										)}
									{allowedModulePermissions?.some(
										item => item.path === '/control_group_templates/',
									) && (
										<SidebarLink
											title="Control Group Templates"
											icon="book"
											route="/control_group_templates/"
											onClick={onClick}
										/>
									)}
									{allowedModulePermissions?.some(
										item =>
											item.path === '/one_servers/' ||
											item.path === '/regions/' ||
											item.path === '/all_virtual_machines/' ||
											item.path === '/all_private_networks/' ||
											item.path === '/vm_templates/' ||
											item.path === '/all_kubernetes/' ||
											item.path === '/manage_notifications/' ||
											item.path === '/logs/',
									) && (
										<SidebarCategory
											title="Infrastructure Services"
											icon="lnr lnr-construction"
											collapse={collapse}
										>
											{allowedModulePermissions?.some(
												item => item.path === '/all_virtual_machines/',
											) && (
												<SidebarLink
													title="Virtual Machines"
													route="/all_virtual_machines/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/all_private_networks/',
											) && (
												<SidebarLink
													title="Private Networks"
													route="/all_private_networks/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/regions/',
											) && (
												<SidebarLink
													title="Regions"
													route="/regions/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/one_servers/',
											) && (
												<SidebarLink
													title="OneServer"
													route="/one_servers/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/vm_templates/',
											) && (
												<SidebarLink
													title="VM Template"
													route="/vm_templates/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/all_virtual_gateway/',
											) && (
												<SidebarLink
													title="Virtual Gateway"
													route="/all_virtual_gateway/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/all_kubernetes/',
											) && (
												<SidebarLink
													title="Kubernetes"
													route="/all_kubernetes/"
													onClick={onClick}
												/>
											)}
											{allowedModulePermissions?.some(
												item => item.path === '/gpuone/',
											) && (
												<>
													<SidebarLink
														title="GPU One"
														route="/gpuone/"
														onClick={onClick}
													/>
												</>
											)}
											{monitoringUrl && (
												<SidebarExternalLink
													title="Monitoring"
													url={monitoringUrl}
													onClick={onClick}
												/>
											)}
										</SidebarCategory>
									)}
									{allowedModulePermissions?.some(
										item => item.path === '/logs/',
									) && (
										<SidebarLink
											title="All Logs"
											icon="history"
											route="/logs/"
											onClick={onClick}
										/>
									)}
									{allowedModulePermissions?.some(
										item => item.path === '/grafana_dashboard/',
									) && (
										<SidebarLink
											title="Grafana Dashboard"
											icon="history"
											route="/grafana_dashboard/"
											onClick={onClick}
										/>
									)}
									{allowedModulePermissions?.some(item =>
										item.path.includes('onboarding'),
									) &&
										scopePermissions?.isStnUser && (
											<SidebarCategory
												title="Onboarding"
												icon="lnr lnr-license"
												collapse={collapse}
											>
												<SidebarLink
													title="Questionnaires"
													icon="graduation-hat"
													route="/onboarding_questionnaire/"
													onClick={onClick}
												/>
												<SidebarLink
													title="Templates"
													icon="graduation-hat"
													route="/onboarding_templates/"
													onClick={onClick}
												/>
											</SidebarCategory>
										)}
									{scopePermissions?.isStnUser &&
										allowedModulePermissions?.some(
											item => item.path === '/skus/',
										) && (
											<SidebarLink
												title="SKUs"
												icon="graduation-hat"
												route="/skus/"
												onClick={onClick}
											/>
										)}
									<SidebarLink
										title="Service Tasks"
										icon="graduation-hat"
										route="/service_tasks/"
										onClick={onClick}
									/>
								</SidebarBlock>
							)}
						<SidebarBlock collapse={collapse}>
							<SidebarNavLink as="div">
								<SidebarLinkTitle
									style={{
										color: colorText,
										fontSize: '11px',
										textTransform: 'uppercase',
									}}
								>
									Build # : {releaseVersion}
								</SidebarLinkTitle>
							</SidebarNavLink>
						</SidebarBlock>
						{scopePermissions?.isStnUser && customerName == 'Stn inc' && (
							<SidebarBlock collapse={collapse}>
								{allowedModulePermissions?.some(
									item => item.path === '/integrations/',
								) && (
									<SidebarLink
										title="Integrations"
										icon="link"
										route="/integrations/"
										onClick={onClick}
									/>
								)}
								{allowedModulePermissions?.some(
									item => item.path === '/manage_notifications/',
								) && (
									<>
										{allowedModulePermissions?.some(
											item => item.path === '/manage_notifications/',
										) &&
											customerName == 'Stn inc' && (
												<SidebarLink
													title="Manage Notifications"
													icon="alarm"
													route="/manage_notifications/"
													onClick={onClick}
												/>
											)}
									</>
								)}
								{allowedModulePermissions?.some(
									item =>
										item.path === '/dev_permission_modules/' ||
										item.path === '/dev_permission_type/' ||
										item.path === '/dev_permission_resource/' ||
										item.path === '/dev_permission_templates/',
								) && (
									<SidebarCategory
										title="Dev Permissions"
										icon="lnr lnr-construction"
										collapse={collapse}
									>
										{scopePermissions?.isStnUser &&
											allowedModulePermissions?.some(
												item => item.path === '/dev_permission_modules/',
											) && (
												<SidebarLink
													title="Modules"
													icon="layers"
													route="/dev_permission_modules/"
												/>
											)}
										{scopePermissions?.isStnUser &&
											allowedModulePermissions?.some(
												item => item.path === '/dev_permission_type/',
											) && (
												<SidebarLink
													title="Module Permissions"
													icon="lock"
													route="/dev_permission_type/"
												/>
											)}
										{scopePermissions?.isStnUser &&
											allowedModulePermissions?.some(
												item => item.path === '/dev_permission_resource/',
											) && (
												<SidebarLink
													title="Resource Permissions"
													icon="lock"
													route="/dev_permission_resource/"
												/>
											)}
										{scopePermissions?.isStnUser &&
											allowedModulePermissions?.some(
												item => item.path === '/dev_permission_templates/',
											) && (
												<SidebarLink
													title="Templates"
													icon="lock"
													route="/dev_permission_templates/"
												/>
											)}
									</SidebarCategory>
								)}
							</SidebarBlock>
						)}
					</>
				) : null}
			</SidebarContentWrap>
		</SkeletonLoader>
	);
};

SidebarContent.propTypes = {
	onClick: PropTypes.func.isRequired,
	collapse: PropTypes.bool,
	changeToLight: PropTypes.func.isRequired,
	changeToDark: PropTypes.func.isRequired,
};

export default SidebarContent;

// region STYLES

const SidebarContentWrap = styled.div`
	height: 100%;
	overflow: auto;
	padding-top: 0;

	& > div:last-child {
		width: 4px !important;

		div {
			transition: height 0.3s;
			opacity: 0.52;
		}
	}

	@media screen and (min-width: 576px) {
		padding-top: 15px;

		${props =>
			props.collapse === true &&
			`
      width: 55px;
      overflow: visible !important;
      transition: width 0.3s;
    `}
	}
`;

export const SidebarBlock = styled.ul`
	padding: 15px 0;
	border-bottom: 1px solid ${colorBorder};
	list-style-type: none;

	&:last-child {
		border: none;
	}

	@media screen and (min-width: 576px) {
		${props =>
			props.collapse &&
			`
      & > li > a,
      & > li > button,
      & > li > div {
        overflow: hidden;
        width: 55px;
        background: ${colorBackground(props)};

        span:last-of-type {
          transition: 0.3s;
        }
        ${SidebarLinkTitle} {
          position: absolute;
          margin-left: 20px;
          width: 160px;
          ${left(props)}: 75px;
        }

        &:hover {
          background: ${colorHover(props)};
        }
      }

      & > li:hover > a,
      & > li:hover > button {
        width: 355px;
      }

      & > li:hover > div {
        width: 300px;
      }

        span {
          opacity: 1;
        }
      }
    `}
	}
`;

const AnchorTag = styled.a`
	height: 36px;
	width: 240px;
	transition: all 0.3s;
	position: relative;
	cursor: pointer;
	display: flex;
	padding: 11px 20px;
	overflow: hidden;
	background: transparent;
	border: none;
	color: ${colorText};
	text-align: ${left};
	font-size: 14px;

	&.active {
		background: ${sidebarColor};

		&:before {
			opacity: 1;
		}
	}

	&:before {
		content: '';
		position: absolute;
		top: 0;
		height: 100%;
		width: 2px;
		background: ${colorAccent};
		opacity: 0;
		transition: all 0.3s;
		${left}: 0;
	}

	&:hover {
		text-decoration: none;
		background-color: ${colorHover};
		color: ${colorText};

		&:before {
			opacity: 1;
		}
	}

	@media screen and (min-width: 576px) {
		width: 100%;

		span {
			position: relative;
			animation: none;
			${left}: 0;
		}
	}
`;

// endregion
